import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/pcm-quotes/:guid?",
    name: "PCM Quotes",
    component: () => import("./pcmQuotes.vue"),
  },
  {
    path: "/pcm-settings",
    name: "PCM Settings",
    component: () => import("./pcmSettings.vue"),
  },
] satisfies RouteRecordRaw[];
